export default __webpack_public_path__ + "static/media/smarts.dd7d25f8.png";